import React from "react";
import { Card } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers"; //, checkIsActive
import {
  TOTAL_PAYXTREME_MADE_FUNDS_CAP,
  FUNDS_CAP,
  TOTAL_COMMISSION,
  TOTAL_PAYXTREME_FUNDS_CAP,
  TOTAL_PENDING_REQUESTED_FUNDS_CAP,
  TOTAL_TRANSACTION_FUNDS_WITH_SC_CAP,
  TOTAL_BANK_TRANSACTIONS_CAP,
  TOTAL_REQUESTED__FUNDS_CAP,
} from "../utils/const";
import NumberFormat from "react-number-format";

export function FundsCounter({ fundCounterList }) {
  const {
    Total_payxtreme_funds = "0",
    Total_payments_made_funds = "0",
    Total_payments_requested_funds = "0",
    Total_pending_request_funds = "0",
    Total_transaction_with_sc = "0",
    Total_commission = "0",
  } = fundCounterList || {};

  const amountFormatter = (amount) => {
    return (
      <NumberFormat
        value={amount}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  return (
    <>
      <div className="history-wrapper container dashboard-statistics">
        <div className="row">
          <div className="col-md-12">
            <div className="dashboard-header d-md-flex justify-content-md-between align-items-center">
              <div className="title d-none d-md-block">
                <h4 className="card-title align-items-center mb-3 mt-4">
                  <span className="card-label font-weight-bolder text-dark">
                    {FUNDS_CAP}
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/total-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_payxtreme_funds)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_PAYXTREME_FUNDS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-success menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/made-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_payments_made_funds)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_PAYXTREME_MADE_FUNDS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-warning menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/request-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_payments_requested_funds)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_REQUESTED__FUNDS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/pending-requested-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_pending_request_funds)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_PENDING_REQUESTED_FUNDS_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4 d-none">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/total-commission.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1 d-none">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_commission)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_COMMISSION}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/sc.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_transaction_with_sc)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      {TOTAL_TRANSACTION_FUNDS_WITH_SC_CAP}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
